export const extentGsmt = [
  -7278753.9878, -3110243.0708, -7240359.4153, -3092280.696,
];

export const extentTucuman = [
  -7660079.145640779, -3295308.06224, -6922051.993571715, -2955175.388289042,
];
